// DEV0002
// app/javascript/dashboard/routes/dashboard/conversation/contact/constants.js
const postCreateContactCRM = {
    // TIPO: "Wintook",
    // nameuser: data.company_name,
    // emailuser: data.email,
    // teluser: data.phone_number,
    // contacto1user: data.name,
    chkRecibirInformacion: '',
    Informacion_form_value: '',
    TIPO_CLIENTE_ID: '',
    ORIGEN_ID: '',
    GIRO_ID: '',
    PAIS_ID: '',
    ESTADO_ID: '',
    CIUDAD_ID: '',
    Razon_form_value: '',
    Producto_form_value: '',
    Empresa_form_value: '',
    Website_form_value: '',
    Comentarios_form_value: '',
    url_site_base: '',
    utm_campaign: '',
    utm_content: '',
    utm_id: '',
    utm_medium: '',
    utm_source: '',
    utm_term: '',
    CALIFICACION_ID: '',
    CALIFICACION_NOMBRE: '',
    VENDEDOR: ''
  };

  export default postCreateContactCRM;